import { Button, ButtonProps } from './Button';
import { cn } from '../../lib/utils';

export interface LoadingButtonProps extends Omit<ButtonProps, 'disabled'> {
  loading?: boolean;
  loadingText?: string;
  disabled?: boolean;
}

export function LoadingButton({
  loading = false,
  loadingText,
  disabled,
  children,
  className,
  ...props
}: LoadingButtonProps) {
  const isDisabled = loading || disabled;

  return (
    <Button
      disabled={isDisabled}
      className={cn("relative flex items-center justify-center", className)}
      {...props}
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
          {loadingText || children}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
